import React from 'react';
import { useNotify, useRedirect, fetchUtils } from 'react-admin';
import FileCopyIcon from '@material-ui/icons/FileCopy';
import { Button, IconButton, Tooltip } from '@material-ui/core';

const fetch = fetchUtils.fetchJson;

function copyEntity (resource, code) {
  const url = `${window.nobid_endpoint}/${resource}/${code}/copy`;
  const token = localStorage.getItem('token');
  const options = { method: 'POST', headers: new Headers({ Authorization: `Bearer ${token}` }) };
  return fetch(url, options);
}

export const CopyIconButton = ({ resource, record }) => {
  const notify = useNotify();
  const redirect = useRedirect();

  const handleCopy = (e) => {
    e.stopPropagation();
    copyEntity(resource, record.code)
      .then(({ json }) => {
        notify('Copied successfully');
        redirect('edit', `/${resource}`, json.id);
      })
      .catch(() => notify('Error copying', 'warning'));
  };

  return (
    <Tooltip title="Copy">
      <IconButton size="small" onClick={handleCopy}>
        <FileCopyIcon fontSize="small" />
      </IconButton>
    </Tooltip>
  );
};

export const CopyButton = ({ resource, record }) => {
  const notify = useNotify();
  const redirect = useRedirect();

  const handleCopy = (e) => {
    e.stopPropagation();
    copyEntity(resource, record.code)
      .then(({ json }) => {
        notify('Copied successfully');
        redirect('edit', `/${resource}`, json.id);
      })
      .catch(() => notify('Error copying', 'warning'));
  };

  return (
    <Button onClick={handleCopy} startIcon={<FileCopyIcon />} style={{ marginLeft: 16 }}>
      Copy
    </Button>
  );
};
